import { render, staticRenderFns } from "./ShellEnergy.vue?vue&type=template&id=61d160b6"
import script from "./ShellEnergy.vue?vue&type=script&lang=js"
export * from "./ShellEnergy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../acquisition-moody-moose/node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports